export default __webpack_public_path__ + "static/media/bancor-icon.47fa8c07.svg";